import React from 'react';
import {
  CurrentInlineAnchor,
  SecondaryInlineAnchor
} from '@/common/helios/Anchor';

type OwnProps = React.PropsWithChildren<{
  section: string;
  style?: 'current' | 'secondary';
  url: string;
}>;

export default function ExternalSiteLink({
  children,
  style = 'secondary',
  section,
  url
}: OwnProps) {
  const Anchor =
    style === 'current' ? CurrentInlineAnchor : SecondaryInlineAnchor;

  return (
    <Anchor
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-analytics-id={`${section} - External Site`}
      data-analytics-attributes={JSON.stringify({ url })}
    >
      {children}
    </Anchor>
  );
}
